module.exports = __webpack_public_path__ + "img/icon-graph.0ac4153e.svg";